module.exports = __webpack_public_path__ + "static/img/settingsucesse1.17e5f5ef.png";